import React from "react";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const LANGS = [
  ["en", "English"],
  ["es", "Español"],
];

export function LanguageSwitcher({ className = "", triggerClassName = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "en").split("-")[0];

  const change = (v) => {
    i18n.changeLanguage(v);
    localStorage.setItem("rf_lang", v);
  };

  return (
    <div className={className}>
      <Select value={current} onValueChange={change}>
        <SelectTrigger data-testid="language-switcher" className={`h-9 gap-1.5 ${triggerClassName}`}>
          <Globe className="h-4 w-4 shrink-0" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {LANGS.map(([code, label]) => (
            <SelectItem key={code} value={code} data-testid={`lang-${code}`}>{label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
